/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFInternalServerError
 */
export interface CRSFInternalServerError {
    /**
     * 
     * @type {string}
     * @memberof CRSFInternalServerError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFInternalServerError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFInternalServerError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFInternalServerError interface.
 */
export function instanceOfCRSFInternalServerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFInternalServerErrorFromJSON(json: any): CRSFInternalServerError {
    return CRSFInternalServerErrorFromJSONTyped(json, false);
}

export function CRSFInternalServerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFInternalServerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFInternalServerErrorToJSON(value?: CRSFInternalServerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

